export default "__VITE_ASSET__DvolrSPh__"